module.exports = __webpack_public_path__ + "static/media/Biblio22.1948fe34.mp4";